import { render, staticRenderFns } from "./MatchPairSlideOption.vue?vue&type=template&id=6a9fa840&"
import script from "./MatchPairSlideOption.vue?vue&type=script&lang=js&"
export * from "./MatchPairSlideOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports